import {lazy} from 'react';

export const HeaderLazy = lazy(() => import(/* webpackChunkName: "header" */ '.'));
